import {authRoles} from 'app/auth';
import React from 'react';

export const CustomersAppConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth    : authRoles.staff,
    routes  : [
        {
            path     : '/customers',
            component: React.lazy(() => import('./CustomersApp'))
        },
    ]
};
